import React from 'react';
import { FixtureDetailsDrawer } from './FixtureDetailsDrawer';
import { ControlDetailsDrawerV2 } from './ControlDetailsDrawerV2';
import { ProductDetailsDrawer } from './ProductDetailsDrawer';
import { MultiSelectionDrawer } from './MultiSelectionDrawer';
import { PresentationDrawerV2 } from './PresentationDrawerV2';
import { RoomDrawerV2 } from './RoomDrawerV2';
import { SettingsDrawerV2 } from './SettingsDrawerV2';
import { PortalProductsDrawer } from './PortalProductsDrawer';
import { CablePathDrawer } from './CablePathDrawer';
import { CableJunctionDrawer } from './CableJunctionDrawer';
// import { ProposalItemsDrawerV2 } from './ProposalItemsDrawerV2'; // Removed - using new import workflow
import { useFloorPlanContext } from '../FloorPlanProvider';

interface FloorPlanDrawersProps {
  onStartMeasurement?: (callback: (pixels: number) => void) => void;
  onStopMeasurement?: () => void;
  isMeasuring?: boolean;
  onScaleUpdate?: () => void;
}

export function FloorPlanDrawers({ 
  onStartMeasurement, 
  onStopMeasurement, 
  isMeasuring,
  onScaleUpdate 
}: FloorPlanDrawersProps = {}) {
  const { floorPlan } = useFloorPlanContext();
  
  return (
    <>
      <FixtureDetailsDrawer />
      <ControlDetailsDrawerV2 />
      <ProductDetailsDrawer />
      <RoomDrawerV2 floorPlanId={floorPlan.id} />
      <MultiSelectionDrawer />
      <PresentationDrawerV2 />
      <PortalProductsDrawer />
      <CablePathDrawer />
      <CableJunctionDrawer />
      {/* <ProposalItemsDrawerV2 /> - Removed, using new import workflow */}
      <SettingsDrawerV2
        onStartMeasurement={onStartMeasurement}
        onStopMeasurement={onStopMeasurement}
        isMeasuring={isMeasuring}
        onScaleUpdate={onScaleUpdate}
      />
    </>
  );
}
